var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('rare-dashboard-header',{on:{"emmitDownload":_vm.triggerDownload,"emmitLogout":_vm.triggerLogout}}),(_vm.showControlPanel)?_c('rare-control-panel'):_vm._e(),_c('router-view'),(_vm.loading)?_c('rare-loading-overlay'):_vm._e(),_c('rare-turned-off-overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }